const { REACT_APP_INSTANCE = 'preview' } = process.env;
module.exports = require(`../config/environment/${REACT_APP_INSTANCE}.json`);